var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgEnrollIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.333 9.33517V10.6687L12.3329 16.0027H5.99875V10.6687H4.66525V16.0027H3.9985C3.26174 16.0027 2.665 15.4059 2.665 14.6692V10.6687C2.665 9.93191 3.26174 9.33517 3.9985 9.33517H6.01609L7.47827 6.56882C7.59828 6.33413 7.76364 6.15944 7.93299 6.08943C8.07434 6.03075 8.21769 6.00142 8.35971 6.00142C8.81444 6.00142 9.18915 6.29879 9.3145 6.75884C9.32917 6.81218 9.34783 6.93553 9.30983 7.15823L8.92311 9.33517H13.333ZM8.00633 4.15985L9.45518 5.27999L9.79122 5.0473L9.20182 3.25641L10.6667 2.40763V2.00025H8.74443L8.22169 0H7.78964L7.26691 2.00025H5.334V2.4103L6.80885 3.23107L6.22944 5.04263L6.54949 5.28399L8.005 4.15919L8.00633 4.15985ZM2.67167 6.1601L4.12052 7.28024L4.45656 7.04755L3.86715 5.25666L5.332 4.40788V4.0005H3.40976L2.88703 2.00025H2.45497L1.93224 4.0005H0V4.41055L1.47485 5.23132L0.895445 7.04288L1.21549 7.28424L2.671 6.15944L2.67167 6.1601ZM13.3397 6.1601L14.7885 7.28024L15.1246 7.04755L14.5351 5.25666L16 4.40788V4.0005H14.0778L13.555 2.00025H13.123L12.6002 4.0005H10.6673V4.41055L12.1422 5.23132L11.5628 7.04288L11.8828 7.28424L13.3383 6.15944L13.3397 6.1601Z",
    fill: "#EE4E56"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEnrollIcon);
export default __webpack_public_path__ + "static/media/enroll-icon.bd9541431c0a9f94d2f3b3264d9eaaae.svg";
export { ForwardRef as ReactComponent };